export default "/images/img_ai.svg?4e96f03d754680971c74035e2118f929";